import { useCallback, useEffect, useState } from 'react'
import { fetchStatement, type HistoryPeriod, type Statement } from './historyApi'
import { statementImagesSettled } from './statementPrint'
import { StatementPrintPortal } from './StatementSheet'

export function useStatementPrinter(subscriberId: string) {
  const [job, setJob] = useState<Statement | null>(null)
  const [printing, setPrinting] = useState(false)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (job === null) return
    let cancelled = false
    const run = async () => {
      await new Promise((resolve) => requestAnimationFrame(resolve))
      await statementImagesSettled()
      if (cancelled) return
      window.print()
      setJob(null)
    }
    void run()
    return () => {
      cancelled = true
    }
  }, [job])

  const print = useCallback(
    async (period: HistoryPeriod) => {
      setError(null)
      setPrinting(true)
      try {
        setJob(await fetchStatement(subscriberId, period))
      } catch (failure) {
        setError(failure)
      } finally {
        setPrinting(false)
      }
    },
    [subscriberId],
  )

  return { print, printing, error, portal: job ? <StatementPrintPortal statement={job} /> : null }
}
